<script setup>
import { computed } from 'vue'
import { formatNumber } from 'devextreme/localization'
import { DxButton } from 'devextreme-vue/button'

const props = defineProps({
  deposits: { type: Array, default: () => [] },
  currentDeposit: { type: Number, default: null },
  disabled: { type: Boolean, default: false },
})
const emit = defineEmits(['deposit-selected'])
const deposits = computed(() => props.deposits.filter(deposit => deposit.id !== props.currentDeposit))
const total = computed(() => deposits.value.reduce((quantity, deposit) => quantity + deposit.stock, 0))
const onSelectDeposit = (e, deposit) => {
  e.event.stopPropagation()
  emit('deposit-selected', deposit)
}
</script>

<template>
  <q-expansion-item
    class="q-mt-sm rounded-borders"
    header-class="bg-grey-2 text-primary rounded-borders"
    switch-toggle-side
    expand-icon="mdi-chevron-right"
    expanded-icon="mdi-chevron-down"
    expand-icon-class="text-light-blue-5"
    expand-separator
    dense
  >
    <template #header>
      <q-item-section>{{ $t('stockInfo.otherDeposits') }}</q-item-section>
      <q-item-section side>
        <q-badge color="primary">
          {{ formatNumber(total, '#,##0.###') }}
        </q-badge>
      </q-item-section>
    </template>
    <q-list separator>
      <q-item
        v-for="deposit in deposits"
        :key="deposit.id"
        clickable
        :disable="props.disabled"
        @click="emit('deposit-selected', deposit)"
      >
        <q-item-section side>
          <dx-button
            icon="mdi mdi-swap-vertical"
            styling-mode="text"
            type="default"
            :hint="$t('stockInfo.selectDeposit')"
            :element-attr="{ 'aria-label': $t('stockInfo.selectDeposit') }"
            :disabled="props.disabled"
            @click="e => onSelectDeposit(e, deposit)"
          />
        </q-item-section>
        <q-item-section>
          <q-item-label>{{ deposit.code }} · {{ deposit.name }}</q-item-label>
        </q-item-section>
        <q-item-section side>
          <div class="row no-wrap items-center q-gutter-x-sm">
            <span class="text-caption">{{ $t('stockInfo.stock') }}</span>
            <span class="text-weight-medium">{{ formatNumber(deposit.stock, '#,##0.###') }}</span>
          </div>
        </q-item-section>
      </q-item>
    </q-list>
  </q-expansion-item>
</template>
